import { useState } from 'react';
import { Badge, Dropdown, Tooltip, Spin } from 'antd';
import { BellOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useNotificationContext } from '../../contexts/notification.context';
import { useServiceStatus } from '@/contexts/service-status';
import { NotificationList } from './NotificationList';

export function NotificationButton() {
  const { unreadCount } = useNotificationContext();
  const { status, isServiceOnline } = useServiceStatus();
  const [open, setOpen] = useState(false);

  const isNotificationServiceOnline = isServiceOnline('notification');
  const isChecking = status.notification === 'checking';

  const handleOpenChange = (visible: boolean) => {
    // Bloquear abertura se servico offline
    if (visible && !isNotificationServiceOnline) return;
    setOpen(visible);
  };

  // Estado de verificacao inicial
  if (isChecking) {
    return (
      <button className="relative flex items-center justify-center w-10 h-10 rounded-full bg-gray-50">
        <Spin size="small" />
      </button>
    );
  }

  // Servico offline - mostrar botao desabilitado com tooltip
  if (!isNotificationServiceOnline) {
    return (
      <Tooltip title="Notificacoes temporariamente indisponiveis">
        <button
          className="relative flex items-center justify-center w-10 h-10 rounded-full bg-gray-100"
          disabled
          style={{ opacity: 0.5, cursor: 'not-allowed' }}
        >
          <Badge
            count={<ExclamationCircleOutlined style={{ color: '#faad14', fontSize: 12 }} />}
            offset={[-4, 4]}
          >
            <BellOutlined className="text-xl text-gray-400" />
          </Badge>
        </button>
      </Tooltip>
    );
  }

  // Servico online - comportamento normal
  return (
    <Dropdown
      open={open}
      onOpenChange={handleOpenChange}
      trigger={['click']}
      dropdownRender={() => (
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 w-80 max-w-sm">
          <NotificationList onClose={() => setOpen(false)} />
        </div>
      )}
      placement="bottomRight"
    >
      <button className="relative flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition-colors">
        <Badge count={unreadCount} overflowCount={99} offset={[-4, 4]}>
          <BellOutlined className="text-xl text-gray-700" />
        </Badge>
      </button>
    </Dropdown>
  );
}
